import Base64 from 'crypto-js/enc-base64'
import Utf8 from 'crypto-js/enc-utf8'
import { JSEncrypt } from 'jsencrypt'
import { getRandomAlphaNumString } from '../strings'
const CryptoJS = require('crypto-js')

/*
 * Method to decrypt the AES encrypted data
 @param - string {encrypted data}
 @param - string {security key}
 */

/*
 * Method to encrypt data using AES algo
 @param - string {data}
 @param - string {security key}
 */

export const AESEncryption = (securityKey: string, data: any) => {
  let keyUtf8 = Utf8.parse(securityKey)
  let cipherPin = CryptoJS.AES.encrypt(data, keyUtf8, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  })

  return cipherPin.ciphertext.toString(Base64)
}

export const RSAEncryption = (key: string, publicKey: string) => {
  //encode and encrypt the random key
  const encrypt = new JSEncrypt()
  encrypt.setPublicKey(publicKey)
  return encrypt.encrypt(key)
}

export const getEncryptedPwdAndKey = (pwd: string, publicKey: string): any => {
  const randomEncKey = getRandomAlphaNumString(32)
  const aesEncString = AESEncryption(randomEncKey, pwd)
  const encryptedKey = RSAEncryption(randomEncKey, publicKey)
  return { password: aesEncString, key: encryptedKey }
}
